// extracted by mini-css-extract-plugin
module.exports = {"content":"fields_content__XiBtZ","center":"fields_center__10GzA","flex":"fields_flex__3PzRT","font":"fields_font__1Xhst"};